import { GET_TOOL_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_TOOL_TYPES_SUCCESS: {
      const toolTypes = action.payload;

      if (!toolTypes){
        return [...state];
      }

      return [
        ...state,
        ...toolTypes
      ]
    }
    default:
      return state;
  }
}
